<article class="login-page">
  <div>
    <section class="university-name-container">
      <figure>
        <img src="images/aum-logo.png" alt="aum Logo" />
      </figure>
      <p>{{ "universityName" | translate }}</p>
    </section>
    <section class="login-form-container">
      <div class="form-intro">
        <p class="login-intro">
          {{ "firstTimeLogin.firstTimeLogin" | translate }}
        </p>
        <p class="login-p">{{ "firstTimeLogin.enterEmail" | translate }}</p>
      </div>

      <form
        [formGroup]="firstTimeLogin"
        (ngSubmit)="onSubmit()"
        class="login-form"
      >
        <app-text-input
          [textControl]="this.firstTimeLogin.controls['email']"
          [config]="{
            placeholder: 'domains.email' | translate,
            minLength: 1,
            maxLength: 50,
            icon: 'username',
            preventSpace: true,
            'margin-block-end': '1em'
          }"
        ></app-text-input>

        <app-form-button
          [config]="{
            text: 'common.confirm' | translate,
            form: this.firstTimeLogin,
            type: 'submit',
          }"
        ></app-form-button>
        <div class="first-time-login">
          <a routerLink="/auth/login" ariaCurrentWhenActive="page">{{
            "login.intro.login" | translate
          }}</a>
        </div>
      </form>
      <footer>
        Copyright &copy; 2023-{{ this.currentYear }} by
        <a target="_blank" href="https://code-mint.com/">CodeMint</a>
      </footer>
    </section>
  </div>
</article>
<figure class="login-top-right-shape">
  <img src="svgs/login/login-top-right-shape.svg" alt="" />
</figure>
<figure class="login-bottom-left-shape">
  <img src="svgs/login/login-bottom-left-shape.svg" alt="" />
</figure>
<section class="logo-container">
  <figure>
    <img src="svgs/app/full-eduminty-logo.svg" alt="EduMinty logo" />
  </figure>
</section>
